/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { SigninComponent } from "./signin/signin.component";
import { SignupComponent } from "./signup/signup.component";
import { VerificationComponent } from "./verification/verification.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommoncomponentsModule } from "src/app/shared/commoncomponents/commoncomponents.module";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ShowHidePasswordDirective } from "./show-hide-password.directive";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { RegisterStoreComponent } from "./register-store/register-store.component";
import { MatInputModule } from "@angular/material/input";
import { WhiteshopLoginComponent } from "./whiteshop-login/whiteshop-login.component";
import { VerifyOtpStoreComponent } from "./register-store/verify-otp-store/verify-otp-store.component";
import { MatSelectModule } from "@angular/material/select";
import { WhiteshopForgotPasswordComponent } from "./whiteshop-forgot-password/whiteshop-forgot-password.component";
import { MatStepperModule } from "@angular/material/stepper";
import { MatCardModule } from "@angular/material/card";
import { AuthFeatureRoutingModule } from "./auth-feature-routing.module";
@NgModule({
  declarations: [
    SigninComponent,
    SignupComponent,
    VerificationComponent,
    RegisterStoreComponent,
    ForgotPasswordComponent,
    ShowHidePasswordDirective,
    ChangePasswordComponent,
    RegisterStoreComponent,
    WhiteshopLoginComponent,
    VerifyOtpStoreComponent,
    WhiteshopForgotPasswordComponent,
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    CommoncomponentsModule,
    MatDialogModule,
    MatInputModule,
    MatStepperModule,
    MatCardModule,
    AuthFeatureRoutingModule,
  ],
  exports: [
    SigninComponent,
    SignupComponent,
    VerificationComponent,
    ForgotPasswordComponent,
  ],
})
export class AuthFeatureModule {}
